import { useEffect, useState } from "react";
import FeaturedProductCard from "./FeaturedProductCard";
import axios from "axios";

function FeaturedProducts() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  useEffect(() => {
    const getFeaturedProducts = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/featured`
      );
      setFeaturedProducts(response.data);
    };
    getFeaturedProducts();
  }, []);
  return (
    <div className="container">
      <div className="border-list">
        <div className=" product-list row ">
          <h2 className="mb-40 mt-4 fw-normal fs-2">New In</h2>
          {featuredProducts.map((producto, i) => {
            return (
              <div key={i} className="col-lg-6 col-xxl-3">
                <FeaturedProductCard
                  producto={producto}
                  name={producto.name}
                  price={producto.price}
                  // img={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/laderhack/products/${producto.img}`}
                  img={`../img/ProductImg2/${producto.img}`}
                  slug={producto.slug}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FeaturedProducts;
